const IMAGES_URL = 'https://images.vaults.fyi'

type ImagePath = 'networks' | 'protocols' | 'tokens'

export const getImageUrl = (path: ImagePath, name: string) => `${IMAGES_URL}/${path}/${name}.png`
